<script setup lang="ts">
withDefaults(
  defineProps<{
    open: boolean
    title?: string
    eyebrow?: string
    description?: string
    size?: 'sm' | 'md' | 'lg' | 'xl' | 'full'
    mobileMode?: 'fullscreen' | 'sheet'
    closeOnBackdrop?: boolean
    closeOnEscape?: boolean
    pending?: boolean
    initialFocus?: string
    role?: 'dialog' | 'alertdialog'
    labelledby?: string
    describedby?: string
    bodyPadding?: 'none' | 'sm' | 'md' | 'lg'
    hideClose?: boolean
    closeLabel?: string
  }>(),
  {
    title: undefined,
    eyebrow: undefined,
    description: undefined,
    size: undefined,
    mobileMode: undefined,
    pending: undefined,
    initialFocus: undefined,
    role: undefined,
    labelledby: undefined,
    describedby: undefined,
    bodyPadding: 'lg',
    hideClose: false,
    closeLabel: undefined,
    closeOnBackdrop: true,
    closeOnEscape: true,
  },
)
defineEmits<{ close: []; 'update:open': [value: boolean] }>()
const overlay = ref<{ focus: () => void; element?: HTMLElement }>()
defineExpose({
  focus: () => overlay.value?.focus(),
  get element() {
    return overlay.value?.element
  },
})
</script>
<template>
  <UiOverlay
    ref="overlay"
    v-bind="$props"
    kind="modal"
    @close="$emit('close')"
    @update:open="$emit('update:open', $event)"
    ><template
      v-for="slot in (
        ['header', 'header-leading', 'header-title', 'header-meta', 'header-actions'] as const
      ).filter((name) => $slots[name])"
      #[slot]
      ><slot :name="slot"
    /></template>
    <slot /><template
      v-if="$slots.footer"
      #footer
      ><slot name="footer" /></template
  ></UiOverlay>
</template>
